module.exports = __webpack_public_path__ + "static/media/loadingGif.508cf0dd.gif";